import { render, staticRenderFns } from "./CreateBackup.vue?vue&type=template&id=1f93f124&"
import script from "./CreateBackup.vue?vue&type=script&lang=ts&"
export * from "./CreateBackup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports